import constants from '../constants';

const {
  tabIdentifiers,
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
} = constants;

const getTabIdByFieldName = (fieldName) => {
  if (FIELD_NAMES_IN_GENERAL_TAB.includes(fieldName)) {
    return tabIdentifiers.GENERAL;
  }

  if (FIELD_NAMES_IN_SEO_TAB.includes(fieldName)) {
    return tabIdentifiers.SEO;
  }

  if (FIELD_NAMES_IN_CUSTOM_CODE_TAB.includes(fieldName)) {
    return tabIdentifiers.CUSTOM_CODE;
  }

  return null;
};

export default getTabIdByFieldName;
